import { type ValueProvider } from '@angular/core';
import {
  MAT_TOOLTIP_DEFAULT_OPTIONS,
  type MatTooltipDefaultOptions,
} from '@angular/material/tooltip';

export const matTooltipDefaultsProvider: ValueProvider = {
  provide: MAT_TOOLTIP_DEFAULT_OPTIONS,
  useValue: {
    position: 'above',
    showDelay: 250,
    disableTooltipInteractivity: true,
  } as MatTooltipDefaultOptions,
};
